export const MANAGE_MEMBERSHIP_ROUTE = "/manage-membership";
